(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('material', {
                parent: 'module',
                url: '/material',
                data: {
                    authorities: ['ROLE_CLASSIFY']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/material/material.html',
                        controller: 'MaterialController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('materialAdd', {
                parent: 'module',
                url: '/materialAdd',
                data: {
                    authorities: ['ROLE_CLASSIFY']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/material/material-add.html',
                        controller: 'MaterialAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('materialEdit', {
                parent: 'module',
                url: '/materialEdit/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_PRODUCT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/product/material/material-edit.html',
                        controller: 'MaterialEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Material', function($stateParams, Material) {
                        return Material.detail({id: $stateParams.id});
                    }],
                }
            });
    }
})();
